export default {
  statisticData: function(state) {
    return state.data;
  },
  isLoading(state) {
    return state.isLoading;
  }
}
